module.exports = __webpack_public_path__ + "static/media/back-home.1ceb6be1.png";